export { default } from './ResourceCardTile';
